import React from 'react';
import {
  AccountBookOutlined,
  DollarOutlined,
  PayCircleOutlined,
} from '@ant-design/icons';

export interface MenuItemConfig {
  key: string;
  icon: React.ReactNode;
  label: string;
  children?: { key: string; label: string }[];
}

/** 财务中心菜单 IA（本期不含客户管理 / 代理管理） */
export const topMenuConfig: MenuItemConfig[] = [
  {
    key: '/ledger',
    icon: <AccountBookOutlined />,
    label: '应收应付对账表',
    children: [
      { key: '/ledger', label: '应收应付视图' },
      // 详情页由视图行进入；侧栏仍给出可点占位入口
      { key: '/ledger/demo', label: '应收应付详情' },
    ],
  },
  {
    key: '/receivables',
    icon: <DollarOutlined />,
    label: '应收管理',
    children: [{ key: '/receivables', label: '客户应收' }],
  },
  {
    key: '/payables',
    icon: <PayCircleOutlined />,
    label: '应付管理',
    children: [{ key: '/payables', label: '代理应付' }],
  },
];
